
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class LogEntryMailModel extends Model<LogEntryMailModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'sendDateTime', type: 'Date' },
		{ name: 'recipients', type: 'string[]', isArray: true },
		{ name: 'subject', type: 'string' },
		{ name: 'sender', type: 'string' },
		{ name: 'attachments', type: 'LogEntryMailAttachmentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new LogEntryMailAttachmentModel }, properties: () => { return LogEntryMailAttachmentModel.classProperties } }
	];
	[key: string]: any;
	
	public sendDateTime?: Date;
	public recipients: string[];
	public subject: string;
	public sender: string;
	public attachments: LogEntryMailAttachmentModel[];
    
	constructor(){
		super();
		this.sendDateTime = undefined;
		this.recipients = [];
		this.subject = '';
		this.sender = '';
		this.attachments = [];
		
	}
	getProperties(){
		return LogEntryMailModel.classProperties;
	}
}
export class LogEntryMailAttachmentModel extends Model<LogEntryMailAttachmentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'filePath', type: 'string' },
		{ name: 'containerName', type: 'string' },
		{ name: 'attachmentName', type: 'string' }
	];
	[key: string]: any;
	
	public filePath: string;
	public containerName: string;
	public attachmentName: string;
    
	constructor(){
		super();
		this.filePath = '';
		this.containerName = '';
		this.attachmentName = '';
		
	}
	getProperties(){
		return LogEntryMailAttachmentModel.classProperties;
	}
}

